import api from './api';

const smartScheduleService = {
  // Obter configuração
  getConfig: async () => {
    try {
      const response = await api.get('/smart-schedule/config');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar configuração:', error);
      throw error;
    }
  },

  // Atualizar configuração
  updateConfig: async (configData) => {
    try {
      const response = await api.put('/smart-schedule/config', configData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar configuração:', error);
      throw error;
    }
  },

  // Encontrar melhor slot
  findBestSlot: async (params) => {
    try {
      console.log('🔍 [SERVICE] findBestSlot chamado:', params);
      const response = await api.post('/smart-schedule/find-best-slot', params);
      console.log('✅ [SERVICE] Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao buscar melhor slot:', error);
      throw error;
    }
  },

  // Encontrar melhor slot para cliente antigo (retorno) - lógica simplificada
  findBestSlotReturning: async (params) => {
    try {
      console.log('🔍 [SERVICE] findBestSlotReturning chamado:', params);
      const response = await api.post('/smart-schedule/find-best-slot-returning', params);
      console.log('✅ [SERVICE] Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao buscar melhor slot para retorno:', error);
      throw error;
    }
  },

  // Buscar datas disponíveis para cliente retorno (calendário)
  getReturningAvailableDates: async (params) => {
    try {
      console.log('🔍 [SERVICE] getReturningAvailableDates chamado:', params);
      const response = await api.get('/smart-schedule/returning-available-dates', { params });
      console.log('✅ [SERVICE] Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao buscar datas disponíveis:', error);
      throw error;
    }
  },

  // Buscar horários de uma data específica para cliente retorno
  getReturningSlotsByDate: async (params) => {
    try {
      console.log('🔍 [SERVICE] getReturningSlotsByDate chamado:', params);
      const response = await api.get('/smart-schedule/returning-slots-by-date', { params });
      console.log('✅ [SERVICE] Resposta:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao buscar horários por data:', error);
      throw error;
    }
  },

  // Agendar levantamento
  scheduleLevantamento: async (data) => {
    try {
      console.log('📅 [SERVICE] scheduleLevantamento chamado:', data);
      const response = await api.post('/smart-schedule/schedule-levantamento', data);
      console.log('✅ [SERVICE] Agendamento criado:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ [SERVICE] Erro ao agendar:', error);
      throw error;
    }
  },

  // Calcular potencial
  calculatePotential: async (firstContactId) => {
    try {
      const response = await api.post(`/smart-schedule/calculate-potential/${firstContactId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular potencial:', error);
      throw error;
    }
  },

  // Calcular potencial em lote
  batchCalculatePotential: async () => {
    try {
      const response = await api.post('/smart-schedule/batch-calculate-potential');
      return response.data;
    } catch (error) {
      console.error('Erro ao calcular potencial em lote:', error);
      throw error;
    }
  },

  // Obter fila de espera
  getWaitingList: async (params = {}) => {
    try {
      const response = await api.get('/smart-schedule/waiting-list', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar fila de espera:', error);
      throw error;
    }
  },

  // Adicionar à fila de espera
  addToWaitingList: async (data) => {
    try {
      const response = await api.post('/smart-schedule/waiting-list', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar à fila de espera:', error);
      throw error;
    }
  },

  // Atualizar status na fila de espera
  updateWaitingListStatus: async (id, data) => {
    try {
      const response = await api.patch(`/smart-schedule/waiting-list/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status na fila de espera:', error);
      throw error;
    }
  },

  // Remover da fila de espera
  removeFromWaitingList: async (id) => {
    try {
      const response = await api.delete(`/smart-schedule/waiting-list/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover da fila de espera:', error);
      throw error;
    }
  },

  // Obter configuração de scores
  getWaitingListScoreConfig: async () => {
    try {
      const response = await api.get('/smart-schedule/waiting-list-config');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar configuração de scores:', error);
      throw error;
    }
  },

  // Atualizar configuração de scores
  updateWaitingListScoreConfig: async (data) => {
    try {
      const response = await api.put('/smart-schedule/waiting-list-config', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar configuração de scores:', error);
      throw error;
    }
  }
};

export default smartScheduleService;
